import { createAsyncThunk } from '@reduxjs/toolkit'

import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../application/application-slice'
// controller code
import { Player, PlayerRole } from '../../models'

export type CreateUpdatePlayerArg = {
  playerRequest: Player
}

export type SetPlayerRolesArg = {
  playerRoles: PlayerRole[]
  playerId: string
}

export type GetPlayerArg = {
  playerId: string
}

export type GetPlayersArg = {
  search: string
}

export const CreateUpdatePlayerAsync = createAsyncThunk<
  any,
  CreateUpdatePlayerArg,
  any
>(
  'composer/playerController/create/update/player',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('playerController/create/update/player'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const SetPlayerRolesAsync = createAsyncThunk<
  any,
  SetPlayerRolesArg,
  any
>(
  'composer/playerController/set/player/roles',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(
        ResolveUrl('playerController/set/player/roles'),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        },
      )
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const GetPlayerAsync = createAsyncThunk<any, GetPlayerArg, any>(
  'composer/playerController/get/player',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(ResolveUrl('playerController/get/player'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${bearToken}`,
          'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify(params),
      })
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
export const GetPlayersAsync = createAsyncThunk<any, GetPlayersArg, any>(
  'composer/playerController/get/players',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      let response = await fetch(ResolveUrl('playerController/get/players'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${bearToken}`,
          'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify(params),
      })
      let res = await response.json()
      return res
    } else {
      throw 'not signed in'
    }
  },
)
